import { $sceneMapApi } from '@stores/dataStores';
import type { GeneralID } from '@types';

export function deleteHotspots({
  sceneId,
  hotspotIds,
}: {
  sceneId: GeneralID;
  hotspotIds: string | Set<string>;
}) {
  let idSet: Set<string>;
  if (typeof hotspotIds === 'string') {
    idSet = new Set([hotspotIds]);
  } else {
    idSet = hotspotIds;
  }

  $sceneMapApi.updateScene({
    id: sceneId,
    updater: (draft) => {
      draft.hotspot = draft.hotspot!.filter((x) => !idSet.has(x.id));
      const groupList = draft.groups?.list;
      if (groupList) {
        groupList.forEach((g) => {
          g.hotspots.list = g.hotspots.list.filter((_id) => !idSet.has(_id));
        });
      }
      const layerList = draft.config?.layers?.list;
      if (layerList) {
        layerList.forEach((l) => {
          l.hotspotIds = l.hotspotIds.filter((_id) => !idSet.has(_id));
        });
      }

      // 遍历热点, 过滤高级交互设置-热点控制, 清除被删除的redid
      draft.hotspot?.forEach((x) => {
        if (x.extendAction?.hotspots) {
          x.extendAction.hotspots = x.extendAction.hotspots.filter(
            (x) => !idSet.has(x.id)
          );
        }
      });
    },
  });
}
